import React from 'react'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root')

if (container) {
  // Keep the bootstrap inside its explicit resource budget. Providers, the
  // route table, and Apollo are loaded as one async application chunk while
  // the server-rendered shell remains immediately available.
  import('./SpaRoot').then(({ SpaRoot, initializeRouteOrganization }) => {
    initializeRouteOrganization()
    createRoot(container).render(<SpaRoot />)
  })
}
